import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule} from '@angular/core';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ScriptLoaderService } from "helpers/services/script-loader.service";
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpRequestInterceptor } from 'core/authentication/interceptor/http-request-interceptor';
import { ParkingDataService } from 'core/data-services/parking/parking.service';
import { GlobalErrorHandler } from 'helpers/services/error-handler.service';
import { ThemeComponent } from 'theme/theme.component';
import { LayoutModule } from 'theme/layouts/layout.module';
import { ThemeRoutingModule } from 'theme/theme-routing.module';
import { AuthModule } from 'pages/authentication/auth.module';

import { PricingDataService } from 'core/data-services/pricing/pricing.service';
import { SettingsDataService } from 'core/data-services/settings/settings.service';
import { PriviledgeDataService } from 'core/data-services/priviledge/priviledge.service';
import { DashboardDataService } from 'core/data-services/dashboard/dashboard.service';
import { MainAlertService } from 'helpers/services/main-alert.service';
import { UsersDataService } from 'core/data-services/users/users.service';
import { ShareDataService } from 'core/data-services/share/share.service';
import {ReportDataService} from 'core/data-services/report/report.service';
import {OneMoveDataService} from 'core/data-services/1move/1move.service';
import {SubscriptionDataService} from 'core/data-services/parking/subscription.service';
import {TypeValidationGuard} from './type-validation.guard';

@NgModule({
  declarations: [
    ThemeComponent,
    AppComponent
  ],
  imports: [
    LayoutModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    ThemeRoutingModule,
    AuthModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true},
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    GlobalErrorHandler,
    ParkingDataService,
    SubscriptionDataService,
    ReportDataService,
    OneMoveDataService,
    ScriptLoaderService,
    PricingDataService,
    SettingsDataService,
    PriviledgeDataService,
    DashboardDataService,
    UsersDataService,
    MainAlertService,
    ShareDataService,
    TypeValidationGuard
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts